import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col } from "reactstrap"
import CountUp from "react-countup"

const StatsSection = () => {
    const { t } = useTranslation()

    const stats = [
        { end: 5000, suffix: "+", label: t("stats.users") },
        { end: 50, suffix: "+", label: t("stats.organizations") },
        { end: 10, suffix: "+", label: t("stats.experience") },
        { end: 98, suffix: "%", label: t("stats.satisfaction") }
    ]

    return (
        <section
            className="section"
            style={{
                background: "linear-gradient(135deg, #1E3A5F 0%, #0D1F33 100%)"
            }}
        >
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center mb-4">
                        <h4 className="title text-white mb-0">{t("stats.title")}</h4>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    {stats.map((stat, key) => (
                        <Col lg={3} md={6} xs={6} className="mt-4 pt-2" key={key}>
                            <div className="counter-box text-center">
                                <h2 className="mb-0 text-white fw-bold">
                                    <CountUp
                                        start={0}
                                        end={stat.end}
                                        duration={2.5}
                                        separator=","
                                    />
                                    {stat.suffix}
                                </h2>
                                <p className="text-white-50 mb-0 mt-2">{stat.label}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default StatsSection
